import React from "react";
import { LocalizeText } from "components/localizer";
import { Grid, MenuItem, TextField } from "@mui/material";
import CommunityContext from "contexts/community";
import { IUsePaginationStore } from "utils/usePaginationStore";

interface ICommunityFilterInputProps {
    pagination: IUsePaginationStore<
        | "products"
        | "members"
        | "mail-templates"
        | "invoice-events"
        | "external-memberships"
        | "representatives"
        | "representative-invitations"
    >;
}

interface IState {
    communities: string[];
}

const filterParamMapping: Record<keyof IState, string> = {
    communities: "communities",
};

const CommunityFilterInput: React.FC<ICommunityFilterInputProps> = ({ pagination }) => {
    const { communitiesPagination } = React.useContext(CommunityContext);

    const [state, setState] = React.useState<IState>({
        communities: [],
    });

    React.useEffect(() => {
        const communities = pagination.getParam("communities");

        setState({
            communities: communities == null || communities === "" ? [] : (communities as string).split(","),
        });
        communitiesPagination.getInitial();
        // eslint-disable-next-line
    }, []);

    const onChange = (type: keyof IState, value: string): void => {
        if (value) {
            setState({ ...state, [type as string]: value });
            pagination.setParam(filterParamMapping[type], value.toString());
            pagination.getInitial();
        } else {
            pagination.setParam(filterParamMapping[type], null);
        }
    };

    return (
        <Grid container justifyContent={"flex-end"} alignItems={"baseline"} rowSpacing={4}>
            <Grid item xs={4}>
                <LocalizeText tag="arenas" />
            </Grid>
            <Grid container item xs={8} alignItems={"baseline"} flexWrap={"nowrap"}>
                <TextField
                    select
                    variant="standard"
                    fullWidth
                    SelectProps={{
                        multiple: true,
                    }}
                    value={state.communities}
                    onChange={(event) => onChange("communities", event.target.value)}
                >
                    {communitiesPagination.results.map((item) => (
                        <MenuItem key={item.uuid} value={item.uuid}>
                            {item.title}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    );
};

export default CommunityFilterInput;
